const question = {
    yes: { point: [3] },
    no: { point: [1] },
};

export default question;
